import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { PublicHomeNav } from '../../Common/PublicComponents/PublicHomeNav';
import { Dropdown, Segment, Message, Grid, Button, Icon } from 'semantic-ui-react';
import { useHistory, useLocation } from 'react-router';
import { PUBLIC_SITE_URL_ACTIVE_MAP } from '../../../App';
import { useProvidersList } from '../Providers/useProvidersList';
import { PublicSkipContentLink } from '../../Common/PublicComponents/PublicSkipContentLink';
import { utils } from '../../../helpers/utils';
import AppConfig from '../../../Constants/config';

export function PublicProviderDetail() {
    const currLocation = useLocation();
    const currHistory = useHistory();
    const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
    const inputClassName = 'ui icon input public-site fluid search-input';
    const defaultProviderCategoryId = useMemo<number>(() => { return getProviderCategoryId(currLocation.search) }, []);
    const [pageSize, totalRecords, currentPage, pageSizeOptions, searchRef, searchText,
        columns, data, isLoading, isDesc, sortColumnName,
        masterData, providerCategoryId, providerCategoryText, providerCredentialIds, providerTraningsIds, providerTypeId,
        handlePageSizeChange, handleSearchChange, resetSearch, handlePaginationChange, handleSortChange,
        handleProviderCategoryChange, handleProviderCredentialsChange, handleProviderTrainingsChange, handleProviderTypeChange] = useProvidersList(defaultProviderCategoryId, false, AppConfig.PUBLIC_PROVIDER_DETAIL_STATE);

    const totalPages: number = Math.ceil(totalRecords / pageSize);
    const paginationArray: (number | string)[] = utils.getPaginationArray(totalPages, currentPage);

    function getProviderCategoryId(searchString: string = '') {
        let result = 0;
        if (searchString === '' || !searchString.includes('pcid=')) {
            return result;
        } else {
            try {
                let tempSplitResult = searchString.split('?pcid=');
                result = parseInt(tempSplitResult[1]);
                return result;
            } catch (error) {
                return result;
            }
        }
    }

    function changeURLSearchParams(newProviderCategoryId: number) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?pcid=${newProviderCategoryId}`;
        window.history.replaceState({ path: newurl }, '', newurl);
    }
    return (
        <>
            <div className="wrapper">
                <PublicSkipContentLink />
                <PublicHomeNav publicSiteURLActiveMap={PUBLIC_SITE_URL_ACTIVE_MAP} />
                <div className="main" id="content">
                    <section className="section section-features section-offset section-primary">
                        <header className="section__head">
                            <div className="shell">
                                <div className="section__head-inner">
                                    <h1>Local Training & Education Opportunities</h1>
                                    <nav className="breadcrumbs section__breadcrumbs">
                                        <ul>
                                            <li>
                                                <Link to="/">Home</Link>
                                            </li>

                                            <li>
                                                <Link to="/EducationOpportunities">Local Training & Education Opportunities</Link>
                                            </li>

                                            <li className="is-current" style={{ marginLeft: '0.5rem' }}>{providerCategoryText}</li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </header>

                        <div className="section__body">
                            <div className="shell">
                                <div className="section__body-inner public-site">
                                    <p>Category</p>
                                    <Dropdown
                                        className='public-site'
                                        placeholder='Provider Category'
                                        selection
                                        value={providerCategoryId || 0}
                                        options={masterData ? masterData.providerCategorys : []}
                                        onChange={(event, data) => {
                                            handleProviderCategoryChange(data.value as number);
                                            changeURLSearchParams(data.value as number);
                                        }}
                                    />
                                </div>
                                <div className="section__body-actions public-site">
                                    <a href="javascript: void(0);" className="btn btn-filter"
                                        title={`Click to ${!isFilterOpen ? 'show' : 'hide'} filters`}
                                        onClick={() => { setIsFilterOpen((previouseValue) => { return !previouseValue; }) }}
                                        aria-expanded={isFilterOpen}
                                    >
                                        Filter
                                        <span className="ico-filter">
                                            <img src="assets/images/svg/ico-filter.svg" alt="" width="15" height="14" />
                                        </span>
                                        {
                                            isFilterOpen ?
                                                <Icon name='angle down' />
                                                :
                                                <Icon name='angle up' />
                                        }
                                    </a>
                                </div>
                                {
                                    masterData !== null &&
                                    <Segment
                                        padded='very'
                                        className={isFilterOpen ? 'public-site' : 'public-site hidden'} color='red' loading={isLoading} style={{ marginBottom: '2.0rem' }}>
                                        <Grid>
                                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                                <label>Search by provider name: </label>
                                                <div className={isLoading ? inputClassName + ' loading' : inputClassName}>
                                                    {
                                                        searchText && <Button icon onClick={resetSearch}>
                                                            <Icon name='times' />
                                                        </Button>
                                                    }
                                                    <input ref={searchRef} onChange={handleSearchChange} placeholder='Search...' />
                                                    <i aria-hidden="true" className="search icon"></i>
                                                </div>
                                            </Grid.Column>

                                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                                <label>Provider Type: </label>
                                                <Dropdown
                                                    className='public-site'
                                                    fluid
                                                    placeholder='Any Type'
                                                    selection
                                                    value={providerTypeId}
                                                    options={(masterData?.providerTypes) || []}
                                                    onChange={(event, data) => {
                                                        handleProviderTypeChange(data.value as number);
                                                    }}
                                                />
                                            </Grid.Column>
                                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                                <label>Provider Credential(s): </label>
                                                <Dropdown
                                                    className='public-site'
                                                    placeholder='Any Credential'
                                                    multiple
                                                    fluid
                                                    selection
                                                    clearable
                                                    closeOnChange={true}
                                                    value={providerCredentialIds}
                                                    options={(masterData?.providerCredentials) || []}
                                                    onChange={(event, data) => {
                                                        handleProviderCredentialsChange(data.value as number[]);
                                                    }}
                                                />
                                            </Grid.Column>
                                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                                <label>Training Offered: </label>
                                                <Dropdown
                                                    className='public-site'
                                                    fluid
                                                    placeholder='Any Training'
                                                    multiple
                                                    selection
                                                    search
                                                    clearable
                                                    closeOnChange={true}
                                                    value={providerTraningsIds}
                                                    options={(masterData?.providerTranings) || []}
                                                    onChange={(event, data) => {
                                                        handleProviderTrainingsChange(data.value as number[]);
                                                    }}
                                                />
                                            </Grid.Column>
                                        </Grid>
                                    </Segment>
                                }
                                {
                                    isLoading && data.length === 0 &&
                                    <Segment loading basic style={{ minHeight: "20rem" }}></Segment>
                                }
                                {
                                    !isLoading && data.length > 0 &&
                                    <ul className="tiles-primary provider-tiles">
                                        {
                                            data.length > 0 &&
                                            data.map((item, rowIndex) => {
                                                return (
                                                    <li key={rowIndex}>
                                                        <h2 style={{marginBottom:'0'}}>{item.providerName}</h2>
                                                        {
                                                            item.address &&
                                                            <p style={{fontSize:'1.75rem', marginTop: '0.25rem'}}>
                                                                {item.address}
                                                            </p>
                                                        }
                                                        {
                                                            !item.address &&
                                                            <p style={{height: '2.5rem', marginTop: '0.25rem'}}>
                                                                {" "}
                                                            </p>
                                                        }
                                                        <dl style={{maxWidth:'100%', width:'100%'}}>
                                                            <dt style={{width:'15.8rem'}}>Provider Type</dt>
                                                            <dd style={{width:'25rem'}}>{item.providerType}</dd>
                                                            <dt style={{width:'15.8rem'}}>Credential</dt>
                                                            <dd style={{width:'calc(100% - 57rem)', whiteSpace:'unset'}}>{item.providerCredential}</dd>
                                                        </dl>
                                                        <dl>
                                                            <dt style={{width:'15.8rem'}}>Training Offered</dt>
                                                            <dd style={{width:'calc(100% - 16rem)', whiteSpace:'unset'}}>{item.trainingOffered}</dd>
                                                        </dl>
                                                        {
                                                            item.contact &&
                                                            <dl>
                                                                <dt style={{width:'15.8rem'}}>Contact</dt>
                                                                <dd style={{width:'calc(100% - 16rem)'}}>
                                                                    {item.contact}
                                                                    <ul className="list-contacts">
                                                                        {
                                                                            item.email &&
                                                                            <li>
                                                                                <a href={`mailto:${item.email}`}>
                                                                                    <span className="ico-mail">
                                                                                        <img src="assets/images/svg/ico-email.svg" alt="" width="24" height="24" />
                                                                                    </span>

                                                                                    {item.email}
                                                                                </a>
                                                                            </li>
                                                                        }
                                                                        {
                                                                            item.phone && utils.formatPhoneNumber(item.phone) &&
                                                                            <li>
                                                                                <a href={`tel:${item.phone}`}>
                                                                                    <span className="ico-phone">
                                                                                        <img src="assets/images/svg/ico-phone.svg" alt="" width="18" height="18" />
                                                                                    </span>
                                                                                    {utils.formatPhoneNumber(item.phone)}
                                                                                </a>
                                                                            </li>
                                                                        }
                                                                        {/* {
                                                                            item.websiteURL &&
                                                                            <li>
                                                                                <a href={item.websiteURL} target="_blank"><Icon name='globe' style={{position:'relative', top:'-0.4rem'}}></Icon>Website</a>
                                                                            </li>
                                                                        } */}
                                                                    </ul>
                                                                </dd>
                                                            </dl>
                                                        }
                                                        {
                                                            item.websiteURL &&
                                                            <>
                                                                <dl>
                                                                    <dd style={{width:'calc(100% - 16rem)', whiteSpace:'unset'}}>
                                                                        <a href={item.websiteURL} target="_blank"><Icon name='globe'></Icon>Website</a>
                                                                    </dd>
                                                        </dl>    
                                                            </>
                                                        }

                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                }
                                {
                                    !isLoading && data.length === 0 &&
                                    <Message warning
                                        size='small'
                                        icon='warning sign'
                                        header='No Record Found'
                                        content='Change filter setting and try other category may be helpful.'
                                    />
                                }

                            </div>
                        </div>
                        <footer className="section__foot">
                            <div className="shell">
                                {
                                    data && data.length > 0 &&
                                    <div className="section__foot-inner">
                                        <div className="pages section__pages">
                                            <div style={{ display: 'inline', position: 'relative', top: '0', fontSize: '1.4rem' }}>
                                                <span style={{ overflowX: "visible", whiteSpace: "nowrap", fontSize: '1.4rem' }}>
                                                    Showing {Math.min((currentPage - 1) * pageSize + 1, totalRecords)} to{" "}
                                                    {currentPage * pageSize > totalRecords
                                                        ? totalRecords
                                                        : currentPage * pageSize}{" "}
                                                    of
                                                    {"  "} {totalRecords} entries{", "}
                                                </span>
                                                <Dropdown className='public-site' inline value={pageSize} options={pageSizeOptions} onChange={handlePageSizeChange} />
                                                <span > entries per page</span>
                                            </div>
                                        </div>
                                        <div className="paging section__paging public-site">
                                            <a href="javascript: void(0);" className={"paging__prev" + (currentPage <= 1 ? ' disabled' : '')}
                                                aria-hidden={currentPage <= 1 ? true : false}
                                                aria-label={`${providerCategoryText} view previous page`}
                                                onClick={(event) => {
                                                    handlePaginationChange(currentPage - 1);
                                                }}
                                            >&nbsp;</a>
                                            <ul>
                                                {
                                                    paginationArray.map((item: number | string, index: number) => {
                                                        if (typeof item === 'string') {
                                                            return <li key={index}>
                                                                <a href="javascript: void(0);" aria-hidden={true} >{item}</a>
                                                            </li>
                                                        } else {
                                                            return <li key={index} className={item === currentPage ? "is-current" : ''}>
                                                                <a href="javascript: void(0);"
                                                                    aria-label={`${providerCategoryText} view page ${item}`}
                                                                    onClick={(event) => {
                                                                        handlePaginationChange(item as number);
                                                                    }}
                                                                >{item}</a>
                                                            </li>
                                                        }
                                                    })
                                                }
                                            </ul>
                                            <a href="javascript: void(0);"
                                                className={"paging__next" + (currentPage >= totalPages ? ' disabled' : '')}
                                                aria-hidden={currentPage >= totalPages ? true : false}
                                                aria-label={`${providerCategoryText} view next page`}
                                                onClick={(event) => {
                                                    handlePaginationChange(currentPage + 1);
                                                }}
                                            >&nbsp;</a>
                                        </div>
                                    </div>
                                }

                            </div>
                        </footer>
                    </section>
                </div>
            </div>
        </>
    );
}